// ** Icons Import
import { Heart } from 'react-feather';

const Footer = () => {
	return <p className="clearfix mb-0"></p>;
};

export default Footer;
